const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function getMonthNumber(monthName) {
  const index = MONTH_NAMES.findIndex(
    (m) => m.toLowerCase() === String(monthName || "").toLowerCase(),
  );
  return index >= 0 ? index + 1 : null;
}

export function filterByMonthYear(data, month, year) {
  return (data || []).filter((item) => {
    const dateObj = new Date(item.date);
    return dateObj.getMonth() + 1 === month && dateObj.getFullYear() === year;
  });
}
